import {cx} from "@emotion/css";

import {designColors} from "~/ui";
import {ReactComponent as SvgFileDown} from "~/assets/svg/file-down.svg";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmFileDownIcon: React.FC<IIconBase> = ({id, size = "sm", color = designColors.black, className}) => {
  return <SvgFileDown id={id} className={cx(simpleIconStyles(size), commonStyles.color(color), className)} />;
};
